//The % operator allows -ve values, which you usually don't want
export function mod(value: number, n: number) {
    return ((value % n) + n) % n;
}
